import {getWindflowServerBaseUrl} from "./api";

export type QueryNewUserStaticsReq = {
    days: number
}

export type UserStaticsData = {
    days: number,
    stats: number[]
}

export type QueryNewUserStaticsResp = {
    code: number
    msg: string
    data: UserStaticsData
}

export function queryNewUserStatics(req: QueryNewUserStaticsReq, callback: (success: boolean, resp?: QueryNewUserStaticsResp) => void) {
    try {
        const options = {
            method: 'GET'
        };
        fetch(getWindflowServerBaseUrl() + "/user/queryNewUserStatics?days=" + req.days, options)
            .then(response => response.json())
            .then(res => {
                try {
                    let resp = res as QueryNewUserStaticsResp;
                    callback(resp.code === 200, resp);
                } catch (e) {
                    callback(false, undefined);
                }
            })
    } catch (e) {
        callback(false, undefined);
    }
}